module.exports = __webpack_public_path__ + "static/media/higher-oak-consulting.01ca875b.md";